<template>
    <div id="record_download">
        <div class="record_title">作品下载记录</div>
        <div class="record_table" v-if="downloadHistory.length == 0">
            <noData :noIndex="3"></noData>
        </div>
        <div class="record_table" v-else>
            <div class="record_table_title">
                <div class="record_table_title1" v-for="(item, i) in tableTitle" :key="i">
                    {{ item }}
                </div>
            </div>
            <div class="record_table_title" v-for="(item, i) in downloadHistory" :key="i">
                <div class="record_table_title1 record_table_title2">
                    {{ item.name}}
                </div>
                <div class="record_table_title1 record_table_title2">
                    {{ item.time }}
                </div>
                <div class="record_table_title1 record_table_title2">
                    <div class="record_table_title3">查看</div>
                    <div class="record_table_title4">删除</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import data from '@/assets/data';
import noData from './no_data.vue';

export default {
    components: {
        noData
    },
    data() {
        return {
            tableTitle: ['书名', '下载时间', '操作'],
            downloadHistory: data.downloadHistory
        }
    }
}
</script>

<style>
#record_download {
    width: 100%;
    height: 100%;
    padding: 35px 25px;
}

.record_title {
    font-weight: bold;
    font-size: 18px;
    color: #111111;
    margin-bottom: 10px;
}

.record_table {
    width: 100%;
    height: calc(100% - 30px);
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.record_table_title {
    display: flex;

}

.record_table_title1 {
    flex: 1;
    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 17px;
    font-size: 15px;
    color: #666666;
    background-color: #F5F7FA;
    border-bottom: 1px solid #E6EBF0;
    border-right: 1px solid #E6EBF0;
}

.record_table_title1:nth-child(1) {
    flex: 3;
}

.record_table_title1:nth-child(2) {
    flex: 2;
}

.record_table_title1:last-child {
    border-right: none;
}

.record_table_title2 {
    background-color: #FFFFFF;
    border-right: none;
}
.record_table_title3{
    color: #548AFF;
    margin-right: 15px;
    cursor: pointer;
}
.record_table_title4{
    color: #FF3030;
    cursor: pointer;
}
</style>